import axiosInstance from "../config/axios.config";

/*
 * The pharmacy's own record of who changed what.
 *
 * Readable by Pharmacy Admins only - the endpoint enforces this, and the
 * screen hides itself from everyone else rather than offering a page that
 * would come back 403.
 *
 * `entity_type` and `entity_id` narrow it to one document; `performed_by`
 * to one person. Paginated like every other pharmacy list.
 */
export const getPharmacyAuditLogsApi = (params) =>
  axiosInstance.get(`pharmacy/audit-logs/?${params}`);

export default getPharmacyAuditLogsApi;
